// extracted by mini-css-extract-plugin
module.exports = {"container":"brandLogoSlider_container__HFt4F","item":"brandLogoSlider_item__Kgiit","slider":"brandLogoSlider_slider__mRJJa","slides":"brandLogoSlider_slides__HfGxy"};